import { QUERY_GET_FACTORY_CATEGORIES } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryCategories = baseThunk(`factoryCategories/getCategories`, QUERY_GET_FACTORY_CATEGORIES, "GET")
